<template>
  <div class="biometric-terms center">
    <div>
      <div class="mb--22">
        <img
          @click="$emit('toggleBiometricTerms')"
          class="biometric-back-btn"
          src="/assets/img/svg/arrow-back.svg"
          alt="back"
        />
        <h3>הרשמה לזיהוי ביומטרי</h3>
      </div>
      <img :src="biometricIconPath" alt="biometric icon" class="mb--22" />
      <h3 style="margin-bottom: 10px;">
        רוצה להיכנס לאפליקציה בזיהוי ביומטרי?
      </h3>
      <div>כניסה מהירה ומאובטחת, ללא צורך בשם משתמש וסיסמה.</div>
      <div>
        הזיהוי מבוסס על הגדרות המכשיר בלבד, ביה"ח אינו שומר את הזיהוי הביומטרי.
      </div>
    </div>
    <div>
      <div class="form_check form_check-white mb--22">
        <label>
          <input type="checkbox" v-model="acceptTerms" />
          מקובלים עלי
          <a
            href="https://hmc.co.il/mymedicaldoctor-terms/"
            @click.stop.prevent="openTerms"
            style="color: white;"
            >תנאי השימוש</a
          >
          של השירות הביומטרי
          <span class="checkmark"></span>
        </label>
        <div
          class="error-message biometric-notice"
          style="text-align: right;"
          v-show="isError"
        >
          יש לאשר את התנאים
        </div>
      </div>
      <button class="bt_blue" @click="handleAcceptTerms">
        כן, רוצה
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BiometricTerms",
  data() {
    return {
      acceptTerms: false,
      isError: false
    };
  },
  computed: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    biometricIconPath() {
      return this.isIOS
        ? "/assets/img/svg/faceid.svg"
        : "/assets/img/svg/fingerprint.svg";
    }
  },
  methods: {
    openTerms() {
      window.open("https://hmc.co.il/mymedicaldoctor-terms/", "_blank");
    },
    handleAcceptTerms() {
      if (this.acceptTerms) {
        this.$emit("acceptTerms");
        this.$emit("toggleBiometricTerms");
      } else {
        this.isError = true;
      }
    }
  }
};
</script>
